import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/subscriptions/service-plan/:servicePlanId/service-plan-terms/:termId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    servicePlanId: string;
    termId: string;
}
const mutationFn = ({ termId, servicePlanId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { termId, servicePlanId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteServicePlanTerm };
